module.exports = __webpack_public_path__ + "img/mgh-kanazawa-sp@2x.0706d957.jpg";